const SDK_VERSION = '7.55.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
